import { Dialog } from 'primereact/dialog';
import React, { Dispatch, FC, SetStateAction, useEffect, useState } from 'react'
import Loader from '../loader';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { APIResponseEntity } from '../../interface/api-responce';
import { AxiosResponse } from 'axios';
import { IsStringNullEmptyOrUndefined } from '../../utils/null-check';
import { APIGetWorkOrderDetailsByStatus } from '../../service/api-service';
import { toast } from 'react-toastify';
import { toastOptObj } from '../../utils/constants';
import { WorkOrderDetailListEntity } from '../../interface/production-planning/work-order-details';

interface RedRibbonDataModelPropEntity {
    isOpen: boolean;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
    title: string;
    status: string
}

const RedRibbonDataModel: FC<RedRibbonDataModelPropEntity> = (
    { isOpen, setIsOpen, status, title }
) => {

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [workOrderDetails, setWorkOrderDetails] = useState<WorkOrderDetailListEntity[] | []>([])

    const handleFetchWorkOrderDetails = async () => {
        if (IsStringNullEmptyOrUndefined(status)) return;
        setIsLoading(true);

        const resp: AxiosResponse<APIResponseEntity> = await APIGetWorkOrderDetailsByStatus(status);

        if (!resp || (resp && ((resp.status !== 200) || !resp.data))) {
            setIsLoading(false);
            return;
        }

        const apiRespPayload: APIResponseEntity = resp.data;

        if (
            (apiRespPayload.statusCode !== 200) ||
            !apiRespPayload.data
        ) {
            toast.error(apiRespPayload.message || apiRespPayload.errorMsg, {
                ...toastOptObj,
            });
            setIsLoading(false);
            return;
        }
        setIsLoading(false);
        setWorkOrderDetails(apiRespPayload.data.data)

    }

    useEffect(() => {
        async function fetchDefaultDetails() {
            await handleFetchWorkOrderDetails()
        }
        fetchDefaultDetails()
    }, [status])

    return (
        <>
            <Loader isLoading={isLoading} />
            <Dialog visible={isOpen} style={{ width: "90vw", display: "flex", justifyContent: "center" }}
                header={
                    <div className="w-100 text-start">
                        <strong>{title}</strong>
                    </div>
                }
                onHide={() => setIsOpen(false)}
            >
                <DataTable
                    value={workOrderDetails}
                    scrollable
                    className="architectsTable"
                    scrollHeight="430px"
                    style={{ border: "1px solid #ccc" }}
                >
                    <Column field="srNo" header="Sr. No" body={(_, { rowIndex }) => <span>{rowIndex + 1}</span>} />
                    <Column
                        field="orderNumber"
                        header="Order Number"
                        body={(row: WorkOrderDetailListEntity) => (row.orderNumber || "").replace(/\/V-\d+$/, "")}
                    />
                    <Column field="woNumber" header="WO Number" />
                    <Column field="projectName" header="Project Name" />
                    <Column field="assigneeDate" header="Last Assigned Date" />
                    <Column field="salesHead" header="User Name" />

                </DataTable>

            </Dialog>
        </>
    )
}

export default RedRibbonDataModel